import { Navigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { useAuth } from '@/lib/auth-context';

export function LoginPage() {
  const { isAuthenticated, isLoading, login } = useAuth();

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50">
      <Card className="w-full max-w-sm">
        <CardHeader className="text-center">
          <div className="mb-2 text-2xl font-bold text-slate-900">Klik PayNow</div>
          <CardTitle className="text-sm font-normal text-slate-500">
            Sign in to access the PayNow Gateway
          </CardTitle>
        </CardHeader>
        <CardContent>
          <Button onClick={login} disabled={isLoading} className="w-full">
            {isLoading ? 'Redirecting...' : 'Sign in with Microsoft'}
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
